<template>
  <vs-row vs-justify="center" id="statistics-box">
    <vs-col type="flex">
      <vs-card id="form">
        <vs-tabs :value="activeTab">
          <vs-tab :label="$t('Statistics.Tabs.Time.Title')" icon="schedule" id="time-tab">
            <WaitingServiceTime :headerTitle="$t('Statistics.Tabs.Time.Chart.Daily')" :waitingServiceTimeParams="{periodical : 'DAILY'}" />
            <WaitingServiceTime :headerTitle="$t('Statistics.Tabs.Time.Chart.Weekly')" :waitingServiceTimeParams="{periodical : 'WEEKLY'}" />
            <WaitingServiceTime :headerTitle="$t('Statistics.Tabs.Time.Chart.Monthly')" :waitingServiceTimeParams="{periodical : 'MONTHLY'}" />
            <WaitingServiceTime :headerTitle="$t('Statistics.Tabs.Time.Chart.Yearly')" :waitingServiceTimeParams="{periodical : 'YEARLY'}" />
          </vs-tab>

          <vs-tab :label="$t('Statistics.Tabs.Frequency.Title')" icon="show_chart" id="frequency-tab">
            <FrequencyCharts :headerTitle="$t('Statistics.Tabs.Frequency.Chart.Daily')" :visitFrequencyParams="{periodical : 'DAILY'}" />
            <FrequencyCharts :headerTitle="$t('Statistics.Tabs.Frequency.Chart.Weekly')" :visitFrequencyParams="{periodical : 'WEEKLY'}" />
            <FrequencyCharts :headerTitle="$t('Statistics.Tabs.Frequency.Chart.Monthly')" :visitFrequencyParams="{periodical : 'MONTHLY'}" />
            <FrequencyCharts :headerTitle="$t('Statistics.Tabs.Frequency.Chart.Yearly')" :visitFrequencyParams="{periodical : 'YEARLY'}" />
          </vs-tab>
          <vs-tab :label="$t('Statistics.Tabs.InclusiveFrequency.Title')" icon="show_chart" id="frequency-tab">
            <vs-row>
              <vs-select
                v-model="selected_businesses"
                :placeholder="$t('Booking.CreatePrompt.ChooseTargetDepartment')"
                label="Industries"
                class="mb-3"
                multiple
                autocomplete
                style="display: inline-block;width: 80%;"
              >
                <vs-select-item
                  :key="index"
                  :value="item.id"
                  :text="item.name"
                  v-for="(item, index) in businesses"
                />
              </vs-select>
              <vs-input
                class="w-20 btn"
                type="button"
                @click="changeCharts"
                :value="$t('Toasts.AcceptButton')"
                style="display: inline-block;margin-top: 22px;"
              />
            </vs-row>
            <InclusiveFrequencyCharts ref="IncDaily" :headerTitle="$t('Statistics.Tabs.Frequency.Chart.Daily')" :visitFrequencyParams="{periodical : 'DAILY'}" />
            <InclusiveFrequencyCharts :headerTitle="$t('Statistics.Tabs.Frequency.Chart.Weekly')" :visitFrequencyParams="{periodical : 'WEEKLY'}" />
            <InclusiveFrequencyCharts :headerTitle="$t('Statistics.Tabs.Frequency.Chart.Monthly')" :visitFrequencyParams="{periodical : 'MONTHLY'}" />
            <InclusiveFrequencyCharts :headerTitle="$t('Statistics.Tabs.Frequency.Chart.Yearly')" :visitFrequencyParams="{periodical : 'YEARLY'}" />
          </vs-tab>

          <vs-tab :label="$t('Statistics.Tabs.Services')" icon="pie_chart" id="frequency-tab">
            <vs-row> 
              <ServicePieChart :headerTitle="$t('Statistics.ServiceFrequency.ServicesPie')" />
              <ServiceFrequency :headerTitle="$t('Statistics.ServiceFrequency.Title')"/>
            </vs-row> 
          </vs-tab>

          <vs-tab :label="$t('Statistics.Tabs.Customers.Title')" icon="person" id="customers-tab">
              <CustomersStats />
          </vs-tab> 
          <vs-tab :label="$t('Statistics.Tabs.Logs')" icon="sync_alt" id="logs-tab">
          </vs-tab> 
        </vs-tabs>
      </vs-card>
    </vs-col>
  </vs-row>
</template>
<script>

import WaitingServiceTime from '../../components/statistics/WaitingServiceTime';
import FrequencyCharts from '../../components/statistics/FrequencyCharts';
import InclusiveFrequencyCharts from '../../components/statistics/InclusiveFrequencyCharts';
import ServicePieChart from '../../components/statistics/ServicePieChart';
import ServiceFrequency from '../../components/statistics/ServiceFrequency';
import CustomersStats from '../../components/statistics/CustomersStats';
import { businessService } from '../../_services'

export default {
  name: 'Statistics',
  data:() => ({
    activeTab: 0,
    selected_businesses: [],
    businesses: []
  }),
  methods: {
    changeCharts(){
      this.$refs.IncDaily.initPage(this.selected_businesses)
    }
  },
  components:{
    WaitingServiceTime,
    FrequencyCharts,
    InclusiveFrequencyCharts,
    ServicePieChart,
    ServiceFrequency,
    CustomersStats
  },
  mounted(){
    businessService.getAllMinified().then(function(data){
      this.businesses = data.data
    }.bind(this))
  }
}
</script>
<style >
.apexcharts-tooltip{
  color: black!important;
}
</style>